const DEFAULT_API_BASE = (
  process.env.REACT_APP_API_BASE || "https://api.matlib.net"
).replace(/\/$/, "");

export const API_BASE_URL = DEFAULT_API_BASE;
export const MATERIAL_URL = `${API_BASE_URL}/material/`;
export const ROOT_SERVER = `${API_BASE_URL}/`;
const PUBLIC_DATA = `${process.env.PUBLIC_URL || ""}/data`;
export const BRAND_INFO_URLS =
  process.env.NODE_ENV === "development"
    ? [
        `${PUBLIC_DATA}/brand-info-nike.json`,
        `${PUBLIC_DATA}/brand-info-adidas.json`,
      ]
    : [`${API_BASE_URL}/brand/`];

export const NIKESTORE = BRAND_INFO_URLS[0];

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
